var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('editor',{attrs:{"tinymceScriptSrc":'/js/tinymce/tinymce.min.js',"init":{
      height: 400,
      width: '100%',
      menubar: 'file edit view insert format table help',
      plugins: [
        'advlist autolink lists link image charmap preview anchor',
        'searchreplace visualblocks code fullscreen',
        'insertdatetime media table code help wordcount',
        'emoticons template codesample autosave hr pagebreak',
        'save directionality textpattern noneditable',
        'quickbars '
      ],
      toolbar: [
        'undo redo | styleselect | bold italic underline strikethrough | forecolor backcolor | fontselect fontsizeselect',
        'alignleft aligncenter alignright alignjustify | outdent indent | numlist bullist | link image media',
        'blockquote subscript superscript | removeformat | charmap emoticons | code fullscreen preview',
        'insertfile template hr pagebreak | ltr rtl | visualblocks visualchars '
      ].join(' | '),
      toolbar_sticky: true,
      autosave_interval: '30s',
      autosave_retention: '2m',
      image_advtab: true,
      image_caption: true,
      imagetools_cors_hosts: ['mydomain.com'],
      quickbars_selection_toolbar: 'bold italic | quicklink h2 h3 blockquote quickimage quicktable',
      contextmenu: 'link image table',
      branding: false,

      skin_url: '/js/tinymce/skins/ui/oxide',
      content_css: '/js/tinymce/skins/content/default/content.css',
      content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px } h1,h2,h3 { color:#333; }',

      file_picker_callback: this.handleFilePicker
    }},on:{"input":_vm.onEditorInput},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})
}
var staticRenderFns = []

export { render, staticRenderFns }